import { Link } from 'react-router-dom';
import { Server, Twitter, Linkedin, Github, ShieldCheck, Activity } from 'lucide-react';
import { Logo } from './Logo';

export function Footer() {
  return (
    <footer className="bg-olo-card border-t border-olo-border pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div className="col-span-1 md:col-span-1">
            <Link to="/" className="flex items-center mb-6 group">
              <Logo className="h-9 w-auto text-white group-hover:opacity-90 transition-opacity" />
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Premium managed WordPress hosting on Google Cloud. Built for digital agencies and high-performance website owners.
            </p>
            <div className="flex gap-4">
              <a href="#" className="text-gray-400 hover:text-olo-green transition-colors" aria-label="Twitter">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-olo-green transition-colors" aria-label="LinkedIn">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-olo-green transition-colors" aria-label="GitHub">
                <Github className="w-5 h-5" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-display font-semibold text-white mb-4">Solutions</h3>
            <ul className="space-y-3">
              <li><Link to="/agencies" className="text-gray-400 hover:text-olo-green text-sm transition-colors">For Agency Owners</Link></li>
              <li><Link to="/owners" className="text-gray-400 hover:text-olo-green text-sm transition-colors">For Website Owners</Link></li>
              <li><Link to="/pricing" className="text-gray-400 hover:text-olo-green text-sm transition-colors">Pricing</Link></li>
              <li><Link to="/infrastructure" className="text-gray-400 hover:text-olo-green text-sm transition-colors">Infrastructure</Link></li>
              <li><Link to="/tools" className="text-gray-400 hover:text-olo-green text-sm transition-colors">Free Tools</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-display font-semibold text-white mb-4">Company</h3>
            <ul className="space-y-3">
              <li><Link to="/" className="text-gray-400 hover:text-olo-green text-sm transition-colors">Home</Link></li>
              <li><Link to="/about" className="text-gray-400 hover:text-olo-green text-sm transition-colors">About Us</Link></li>
              <li><Link to="/compare" className="text-gray-400 hover:text-olo-green text-sm transition-colors">Compare Providers</Link></li>
              <li><Link to="/sitemap" className="text-gray-400 hover:text-olo-green text-sm transition-colors">Sitemap</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-olo-green text-sm transition-colors">Contact</Link></li>
              <li><Link to="/support" className="text-gray-400 hover:text-olo-green text-sm transition-colors">Support</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-display font-semibold text-white mb-4">Legal</h3>
            <ul className="space-y-3">
              <li><Link to="/privacy-policy" className="text-gray-400 hover:text-olo-green text-sm transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms-and-conditions" className="text-gray-400 hover:text-olo-green text-sm transition-colors">Terms of Service</Link></li>
              <li><Link to="/refund-policy" className="text-gray-400 hover:text-olo-green text-sm transition-colors">Refund Policy</Link></li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-olo-border flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} OLO Konnect. All rights reserved.
          </p>
          <div className="flex flex-wrap items-center gap-4 md:gap-6 text-sm text-gray-400">
            <div className="flex items-center gap-2">
              <Server className="w-4 h-4 text-olo-green" />
              <span>Google Cloud Partner</span>
            </div>
            <div className="flex items-center gap-2">
              <ShieldCheck className="w-4 h-4 text-olo-teal" />
              <span>SSL Secure</span>
            </div>
            <div className="flex items-center gap-2">
              <Activity className="w-4 h-4 text-blue-400" />
              <span>24/7 Monitoring</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
